import CompanyProfileDto from '@/models/Companies/CompanyProfileDto';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import DateTimeUtils from '@/lib/dateTimeUtils';
import CalendarType from '../Shared/CalendarType';

export default class FilterJobScheduleViewModel {
    calendarType = CalendarType.Week;
    from: string = DateTimeUtils.getThisMondayAsIso();
    //to: string = DateTimeUtils.getTodayAsIso();
    companies: CompanyProfileDto[] = [];
    selectedCompany: CompanyProfileDto;
    locations: LocationProfileDto[] = [];
    selectedLocation: LocationProfileDto;
    desks: DeskDto[] = [];
    selectedDesk: DeskDto;
    branches: BranchDto[] = [];
    selectedBranch: BranchDto;
}